export function photosSlider() {
    const sliderWrap = $(".photos-slider");
    const slider = sliderWrap.find(".slider");
    const sliderArrows = sliderWrap.find(".slider-arrows");
    const sliderDots = sliderWrap.find(".slider-dots");
    const rtl = this.rtl;
    let curSlide = 0;

    slider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendArrows: sliderArrows,
        appendDots: sliderDots,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                }
            }
        ],
        rtl
    });

    slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      const currentSlickSlide = sliderWrap.find(".slick-dots li").eq(currentSlide);
        if (curSlide < nextSlide) {
            curSlide = nextSlide;
            currentSlickSlide.addClass("shown");
        } else {
            curSlide -= 1;
            currentSlickSlide.removeClass("shown");
        }

        if(sliderWrap.find(".video-play").length) {
          const slider = document.querySelector(".photos-slider");
          const video = slider.querySelector(".video-play video");
          video.pause();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/photos-slider.js